import React, { useState } from "react";
import { Tabs, Spin } from "antd";
import FirmActiveAdverts from "./Components/FirmActiveAdverts";
import FirmPassiveAdverts from "./Components/FirmPassiveAdverts";
import useFirmService from "../../../services/useFirmService";

const styles = {
  container: {
    padding: 24,
  },
  tabsContainer: {
    marginBottom: 16,
  },
  spinContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200,
  },
};

const Adverts = () => {
  const [activeTab, setActiveTab] = useState("1");
  const { useDeleteFirmAdvert } = useFirmService();
  const { mutateAsync: deleteFirmAdvert, isPending } = useDeleteFirmAdvert();

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
  };

  const items = [
    {
      key: "1",
      label: "YAYINDAKİLER",
      children: <FirmActiveAdverts deleteAdvert={deleteFirmAdvert} />,
    },
    {
      key: "2",
      label: "PASİFLER",
      children: <FirmPassiveAdverts deleteAdvert={deleteFirmAdvert} />,
    },
  ];

  return (
    <div style={styles.container}>
      <Spin spinning={isPending}>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          size="middle"
          style={styles.tabsContainer}
          items={items}
        />
      </Spin>
    </div>
  );
};

export default Adverts;
